import React from 'react';
import { FlatList, Image } from 'react-native';
import type { AccountProps, MyPlayerProps } from '../../types';
import { Icons } from '../../Components';
import { useColors } from '../../constants/useColors';
import { Button, Text, View } from '../../Components/Themed';

type AccountAddProps = {
    player:MyPlayerProps,
    accounts:AccountProps[],
    walkthrough?:boolean,
    onManualACH: () => void,
    onLinkACH: () => void,
    onClose: () => void,
    onNext: (account:AccountProps) => void,
}
const ach_add_sections = ['header', 'sub_header', 'link','manual']
const ACHAddCard = ({ accounts, onClose, onNext, onManualACH, onLinkACH }:AccountAddProps) => {
    const Colors = useColors();
    const manual_account = accounts.find(a => a.ach_detail && a.ach_detail.ach_type == 'manual');
    const ibt_account = accounts.find(a => a.ach_detail && a.ach_detail.ach_type == 'ibf' && !a.ibt_placeholder);

    const renderSections = (data:{item:string,index:number}) => {
        switch(data.item){
            case 'header':
                return (
                    <View style={{ padding:20 }}>
                        <Text theme='h1'>GET ACCESS TO YOUR WINNINGS</Text>
                        <Text style={{ marginTop:5 }} theme='description'>At BettorEdge - we celebrate withdraws!  In order to move funds out of your BettorEdge account, you will need to add an eligible bank account.</Text>
                    </View>
                )
            case 'sub_header':
                return (
                    <View style={{ padding:20 }}>
                        <Text theme='h1'>ADD ACH ACCOUNT OPTIONS</Text>
                    </View>
                )
            case 'link':
                return (
                    <View float style={{ padding:20, borderRadius:8 }}>
                        <View transparent style={{ flexDirection:'row' }}>
                            <View float style={{ backgroundColor:Colors.text.white, borderRadius:100, height:50, width:50, justifyContent:'center', alignItems:'center' }}>
                                <Icons.PlaidIcon size={30}/>
                            </View>
                            <View transparent style={{ flex:1, marginLeft:10 }}>
                                <Text size={14} theme='h1'>Link your account using PLAID</Text>
                                <Text style={{ marginTop:3 }} size={12} theme='description'>When you link an account you get access to both instant deposits and instant withdraws.</Text>
                            </View>
                        </View>
                        {!ibt_account ?
                        <Button float style={{ marginTop:20, padding:3, flexDirection:'row', alignItems:'center', borderRadius:30 }}
                            onPress={() => onLinkACH()}>
                            <View transparent style={{  height:50, width:110, borderRadius:100, justifyContent:'center', alignItems:'center', borderWidth:1, borderColor:Colors.borders.light }}>
                                <Image
                                    source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1695821528/1630344814441_wjq98b.png' }}
                                    style={{ width:50, height:30 }}
                                    resizeMode='cover'
                                />
                            </View>
                            <View transparent style={{ flex:1, marginLeft:10 }}>
                                <Text size={14} theme='h1' weight='bold'>LINK ACH ACCOUNT</Text>
                            </View>
                        </Button>
                        :
                        <View transparent style={{ position:'absolute', top:5, right:5, bottom:0}}>
                            <Icons.TransactionSuccessIcon size={45}/>
                        </View>
                        }
                    </View>
                )
            case 'manual':
                return (
                    <View float style={{ marginTop:20, padding:20, borderRadius:8 }}>
                    <View transparent style={{ flexDirection:'row' }}>
                        <View float style={{ height:50, width:50, borderRadius:100, justifyContent:'center', alignItems:'center' }}>
                            <Icons.BankIcon color={Colors.text.h1} size={30}/>
                        </View>
                        <View transparent style={{ flex:1, marginLeft:10 }}>
                            <Text size={14} theme='h1'>Manually add an account</Text>
                            <Text style={{ marginTop:3 }} size={12} theme='description'>Verify the account in 1-3 business days and start transacting.</Text>
                        </View>
                        
                    </View>
                    {!manual_account ?
                    <Button float style={{ marginTop:20, padding:3, flexDirection:'row', alignItems:'center', borderRadius:30 }}
                    onPress={() => onManualACH()}>
                        <View float style={{  height:50, width:50, borderRadius:100, justifyContent:'center', alignItems:'center' }}>
                            <Icons.BankIcon size={22} color={Colors.text.h1} />
                        </View>
                        <View transparent style={{ flex:1, marginLeft:10 }}>
                            <Text size={14} theme='h1'>ADD MANUAL ACH ACCOUNT</Text>
                        </View>
                    </Button>
                    :
                    <View transparent style={{ position:'absolute', top:5, right:5, bottom:0, alignItems:'flex-end'}}>
                        <Icons.TransactionSuccessIcon size={45}/>
                        {manual_account?.status == 'verify' ?
                        <View transparent style={{ marginTop:-10, marginRight:20, padding:10, borderRadius:8 }}>
                            <Text size={14} theme='description'>Manual ACH account is pending verification</Text>
                        </View>
                        :<></>}
                    </View>
                    }
                </View>
                )
            default: return <></>
        }
    }

    return (
        <View style={{ flex:1 }}>
            <FlatList
                data={ach_add_sections}
                key={'ach_add_sections'}
                keyExtractor={(item) => item}
                renderItem={renderSections}
            />
                
                
            <View nativeID='action_row' style={{ flexDirection:'row', justifyContent:'space-between', padding:10 }}>
                <Button
                    title={!ibt_account && !manual_account ? 'DO THIS LATER' : 'All Set!'}
                    title_color={!ibt_account && !manual_account ? Colors.text.error: Colors.text.success}
                    backgroundColor='transparent'
                    onPress={() => onClose()}
                />
                <Button
                    float
                    style={{ borderRadius:100, height:50, width:50, justifyContent:'center', alignItems:'center' }}
                    onPress={() => {
                        if(ibt_account) { return onNext(ibt_account) }
                        if(manual_account){ return onNext(manual_account) }
                        return
                    }}
                    disabled={manual_account || ibt_account ? false : true}
                    >
                    <Icons.ChevronIcon size={20} direction='right' color={Colors.text.h1}/>
                </Button>
            </View>
        </View>
    )
}

export default ACHAddCard